import Experience from '../Experience.js';
import * as THREE from 'three';

import posterVertexShader from '../shaders/poster/vertex.glsl';
import posterFragmentShader from '../shaders/poster/fragment.glsl';

export default class Photo {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.sizes = this.experience.sizes

    this.posterAspectRatio = 191 / 270;

  }

  init() {
    this.setGeometry();
    this.setTextures();
    this.setMaterial();
    this.setMesh();
  }

  setGeometry() {
    this.geometry = new THREE.PlaneGeometry(2, 2, 1, 1);
  }

  setTextures() {
  }

  setMaterial() {
    this.posterShader = {
      uniforms:
      {
        tWebcamPhoto: { value: null },
        uAspectRatio: { value: this.sizes.width / this.sizes.height },
        uPixelRatio: { value: this.sizes.pixelRatio },
      },
      vertexShader: posterVertexShader,
      fragmentShader: posterFragmentShader
    };

    this.material = new THREE.ShaderMaterial(this.posterShader);
  }

  setMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.position.y = -1.;
    this.mesh.position.z = -0.5;
    this.scene.add(this.mesh);
    this.mesh.visible = false;
  }

}